var map = {
	"./components/prepare_for_ajax": 99
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/frontend ^.*prepare_for_ajax$
// module id = 98
// module chunks = 1